import { render, staticRenderFns } from "./CreateAiBusinessPromoter.vue?vue&type=template&id=91e30dca&scoped=true&"
import script from "./CreateAiBusinessPromoter.vue?vue&type=script&lang=js&"
export * from "./CreateAiBusinessPromoter.vue?vue&type=script&lang=js&"
import style0 from "./CreateAiBusinessPromoter.vue?vue&type=style&index=0&id=91e30dca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/jason/development/social-marketing-recovered/client/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e30dca",
  null
  
)

export default component.exports